"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var flickity_1 = __importDefault(require("flickity"));
require("flickity-fade");
var CustomFlickityNavigation_1 = __importDefault(require("../helpers/CustomFlickityNavigation"));
exports.default = (function () {
    if (!document.querySelector('.LPImageSlider__slider'))
        return;
    var previousBtn = document.querySelector('.LPImageSlider__nav .previous');
    var nextBtn = document.querySelector('.LPImageSlider__nav .next');
    var flkty = new flickity_1.default('.LPImageSlider__slider', {
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        selectedAttraction: 0.075,
        lazyLoad: true,
        draggable: false,
        // @ts-ignore
        fade: true
    });
    if (nextBtn && previousBtn) {
        CustomFlickityNavigation_1.default(flkty, previousBtn, nextBtn);
    }
});
